
import { Component, Mixins } from "vue-property-decorator";
import WizardMixin from "../wizard.mixin";
import { mapState } from "vuex";
import { WizardHourFormDto, WizardInformationFormDto } from "@/types/wizard.type";
import { WizardStep } from "@/types/enums.type";
import ValidatedFormMixin from "@/common/mixins/validated-form.mixin";

@Component({
  computed: {
    ...mapState('Wizard', {
      forms: 'hourForms',
      infoForm: 'infoForm'
    })
  }
})
export default class WizardHoursComponent extends Mixins(WizardMixin, ValidatedFormMixin) {
  forms!: WizardHourFormDto[];
  infoForm!: WizardInformationFormDto;
  WizardStep = WizardStep;

  finishForm(): void {
    this.$validator.validateAll().then((isValid: boolean) => {
      if (isValid) {
        this.$validator.reset();
        this.next(WizardStep.Rates);
      }
    });
  }
}
